// Money formatting shared by the SPA (via `@shared/currency`) and the
// send-email edge function. Pure, no imports: it must run in Deno and Vite.
// Codes are lowercase ISO-4217 (e.g. 'gbp'); GBP is the settlement currency.

export const CURRENCY_SYMBOL: Record<string, string> = {
  gbp: "£",
  eur: "€",
  usd: "$",
  ils: "₪",
  rub: "₽",
  pln: "zł",
  czk: "Kč",
  gel: "₾",
  amd: "֏",
};

/**
 * Minor units → compact money string in the given currency, e.g.
 * (1050, 'gbp') → "£10.50", (1000, 'eur') → "€10", (5000, 'pln') → "zł50".
 * Unknown codes fall back to a trailing code: (5000, 'xyz') → "50 XYZ".
 */
export function formatMoney(cents: number, currency: string | null): string {
  const code = (currency ?? "gbp").toLowerCase();
  const amount = cents / 100;
  const num = amount % 1 === 0 ? String(amount) : amount.toFixed(2);
  const symbol = CURRENCY_SYMBOL[code];
  return symbol ? `${symbol}${num}` : `${num} ${code.toUpperCase()}`;
}
